import React from 'react';
import Chip from '@mui/material/Chip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';

/**
 * The verification outcome as a chip, used by both the history table and the
 * Verify Name tool so a status always looks the same.
 *
 * There are three outcomes, not two. 'ambiguous' is deliberately given its own
 * warning colour instead of being folded into pass or fail: two or more
 * DIFFERENT approved names scored at or above the threshold, so it is not a
 * pass — someone still has to choose which name was meant.
 */
const STATUS_COLORS = {
    verified: 'success',
    ambiguous: 'warning',
    not_verified: 'error',
};

const STATUS_ICONS = {
    verified: <CheckCircleOutlineIcon />,
    ambiguous: <HelpOutlineIcon />,
    not_verified: <ErrorOutlineIcon />,
};

export default function VerificationStatusChip({ status, size = 'small' }) {
    const { t } = useTranslation();

    if (!status) {
        return null;
    }

    // An outcome the backend adds later still renders, just without a colour.
    const label = STATUS_COLORS[status]
        ? t(`admin.certificateNames.statuses.${status}`)
        : status;

    return (
        <Chip
            size={size}
            label={label}
            icon={STATUS_ICONS[status]}
            color={STATUS_COLORS[status] ?? 'default'}
            variant={status === 'verified' ? 'filled' : 'outlined'}
        />
    );
}
